import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const NO_SCROLL_ROUTES = [
  '/ganhar-saldo/parceiros',
  '/ganhar-saldo/ofertas',
  '/ganhar-saldo/convidar-amigos',
  '/gastar-saldo/seguro',
  '/gastar-saldo/marketplace',
];

const shouldDisableScroll = (pathname) =>
  NO_SCROLL_ROUTES.some(route => pathname === route);

export const useScrollToTop = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    const isDisabled = shouldDisableScroll(location.pathname);
    const hasHash = location.hash;

    const shouldSkipScroll =
      hasHash || (isDisabled && navigationType !== 'POP');

    if (shouldSkipScroll) return;

    setTimeout(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, navigationType === 'POP' ? 0 : 300);
    
  }, [location.pathname, navigationType]);
};
